// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"_2R-ou","error404":"_3uC2R","shake":"HvBoe"};